import React from 'react';
import Tooltip from '@atlaskit/tooltip';

export const withTooltip = (toolTipContent: React.ReactNode | undefined | null, children: React.ReactNode) => {
  if (!toolTipContent) return '';
  return (
    <div className="task-list-table-cell">
      <Tooltip content={toolTipContent}>{children}</Tooltip>
    </div>
  );
};
